import { Mixins, Component, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import { allCountries } from '@/_type/mobile'
import { emailRegex } from '@/_type/email'
import { AsYouType, CountryCode, parsePhoneNumber } from 'libphonenumber-js'

@Component({
    inheritAttrs: false,
})
export default class SignInUsernameInput extends Mixins<MixinInterface>() {
    @VModel() signInUsername!: string | null

    validateSignInUsername(signInUsername: string) {
        let res: string | boolean = false

        if (signInUsername) {
            if (this.isStringPhone(signInUsername)) {
                let phone = this.sanitizeUsername(signInUsername)
                if (this.phoneHasCode(phone)) {
                    let code = Object.values(allCountries).find((item) => {
                        return phone ? new RegExp(`^\\${item}`).test(phone) : false
                    })

                    if (code) {
                        try {
                            res = parsePhoneNumber(phone).isValid()
                                ? true
                                : this.$t('fe_validation.error_valid_phone').toString()
                        } catch {
                            res = this.$t('fe_validation.error_valid_phone').toString()
                        }
                    } else {
                        res = this.$t('fe_validation.error_valid_contrycode').toString()
                    }
                } else {
                    res = this.$t('fe_validation.error_valid_contrycode').toString()
                }
            } else {
                res = new RegExp(emailRegex).test(signInUsername)
                    ? true
                    : this.$t('fe_validation.error_valid_email').toString()
            }
        } else {
            res = this.$t('fe_validation.error_required').toString()
        }
        return res
    }

    get required() {
        return this.$attrs.hasOwnProperty('required')
    }
}
